const pickersArrowSwitcher = {
  MuiPickersArrowSwitcher: {
    styleOverrides: {
      button: () => ({
        marginRight: 0,
        marginLeft: '5px',
      }),
    },
  },
};

export default pickersArrowSwitcher;
